<span *ngIf="isValidAgent()" class="button-icon-marker cmr-sign no-booking">
    <i *ngIf="allSigned" class="fa fa-pencil-square"></i>
    <i *ngIf="!allSigned" class="fa fa-pencil-square-o"></i>
</span>
